import axios from "axios";
import { apiRequest } from "./axiosInstance";
import { baseUrl } from "../config";
// const baseUrl = "http://localhost:9000/api";
export const getRolesApi = async (params) => {
  try {
     const response = await apiRequest({
        url: "/role/getRoles",
        method: "GET",
        params:params
      });
      return response?.data
  } catch (error) {
    return null;
  }

 
};

export const createRoles = async (data) => {
  try {
    const role = await axios.post(`${baseUrl}/role/createRole`, data);
    return {data:role?.data,sucess:true};
  } catch (error) {
    return null;
  }
};

export const getUserRoles = async () => {
  try {
    const response = await apiRequest({
      url: "/role/getUserRole",
      method: "GET",
      // data:body
    });
    return response?.data;
  } catch (error) {
    console.log(error, "error in api");
    return { status: error?.response?.status, ...error?.response?.data };
  }
};
